<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{ task.name }}</h2>
      </div>
      <!-------------------------- Tablet Screens -------------------------->
      <!-- start -->
      <v-card
        v-if="$vuetify.breakpoint.width <= 980"
        elevation="0"
        class="px-5 mt-5"
        :loading="loading"
        :class="loading ? '' : 'py-1'"
      >
        <div class="d-flex mt-5">
          <div class="d-flex mt-5">
            <v-select
              :items="['Medical', 'Insemination']"
              outlined
              dense
              class="shrink wdt"
              v-model="action"
            ></v-select>
            <v-btn
              color="primary"
              height="40"
              class="ml-4"
              @click="submitRecord"
            >
             {{$t('actionListmod.healthRecord')}}
            </v-btn>
            <v-spacer></v-spacer>
          </div>
        </div>
        <v-card v-if="!items.length" class="inner-card my-4 py-2 px-4">
          <v-card-text>No Data Available</v-card-text>
        </v-card>
        <div v-else>
          <v-card
            v-for="(item, index) in items"
            :key="index"
            class="inner-card my-4 py-4 px-4"
            :elevation="0"
            :style="
              index % 2 !== 0 && {
                backgroundColor: 'rgba(243, 243, 243, 0.5)',
              }
            "
          >
            <v-row no-gutters>
              <v-col cols="1">
                <v-avatar color="primary" size="50">
                  <span class="white--text">AS</span>
                </v-avatar>
              </v-col>
              <v-col cols="11">
                <v-row>
                  <v-col cols="12">
                    <div style="color: #0ebf67">{{$t('actionListmod.iD')}}</div>
                    <div class="text-h5 font-weight-bold">
                      {{ item.animal.animalNumber }}
                    </div>
                  </v-col>
                  <v-col cols="3" style="font-size: 14px">
                    <div>{{$t('actionListmod.tAG')}}</div>
                    <div class="font-weight-bold" style="margin-top: 10px">
                      {{ `#${item.animal.tagNumber}` }}
                    </div>
                  </v-col>
                  <v-col cols="3" style="font-size: 14px">
                    <div>{{$t('actionListmod.dateOfbirth')}}</div>
                    <div class="font-weight-bold" style="margin-top: 10px">
                      {{ item.animal.dob }}
                    </div>
                  </v-col>
                  <v-col cols="3" style="font-size: 14px">
                    <div>{{$t('actionListmod.taskTakenat')}}</div>
                    <div class="font-weight-bold" style="margin-top: 10px">
                      {{ item.priority }}
                    </div>
                  </v-col>
                  <v-col cols="3" style="font-size: 14px">
                    <div>{{$t('actionListmod.gENDER')}}</div>
                    <div class="font-weight-bold" style="margin-top: 10px">
                      {{ item.gender }}
                    </div>
                  </v-col>
                  <v-col cols="3" style="font-size: 14px">
                    <div>{{$t('actionListmod.bREED')}}</div>
                    <div class="font-weight-bold" style="margin-top: 10px">
                      {{ item.animal.breed }}
                    </div>
                  </v-col>
                  <v-col cols="3" style="font-size: 14px">
                    <div>{{$t('actionListmod.regDate')}}</div>
                    <div class="font-weight-bold" style="margin-top: 10px">
                      {{ item.animal.createdAt }}
                    </div>
                  </v-col>
                  <v-col cols="3" style="font-size: 14px">
                    <div>{{$t('actionListmod.status')}}</div>
                    <div>
                      <v-btn
                        x-small
                        rounded
                        min-width="100"
                        :color="item.status !== '1' ? 'green2' : 'red2'"
                        depressed
                        :class="
                          item.status !== '1' ? 'primary--text' : 'red--text'
                        "
                        height="34"
                        style="margin-top: 10px"
                      >
                        {{ item.status == 1 ? "Active" : "Completed" }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-checkbox
              multiple
              v-model="selected"
              :value="item"
              style="margin: 0px; padding: 0px"
              hide-details
              class="v-card-checkbox"
            />
          </v-card>
        </div>
        <v-row class="mt-5">
          <v-col md="6" sm="6" xs="6">
            <label class="subtitle-1 font-weight-medium black--text" for="breed"
              >{{$t('actionListmod.assignTo')}}</label
            >
            <v-text-field
              type="text"
              placeholder="e.g XXXX"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col md="6" sm="6" xs="6">
            <label class="subtitle-1 font-weight-medium black--text" for="breed"
              >{{$t('actionListmod.status')}}</label
            >
            <v-text-field
              type="text"
              placeholder="e.g XXXX"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col md="12" sm="12" xs="12">
            <label class="subtitle-1 font-weight-medium black--text" for="breed"
              >{{$t('actionListmod.nOTE')}}</label
            >
            <v-textarea
              type="text"
              placeholder="e.g XXXX"
              outlined
              dense
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card>
      <!------------------------ End -------------------------->

      <v-card v-else elevation="0" class="px-5">
        <v-card-text>
          <!-- <template>
                        <v-tabs class="tabs-pill" v-model="tab">
                            <v-tab @click="changeUserStatusType('active')">Active({{ activeUsers }})</v-tab>
                            <v-tab @click="changeUserStatusType('progress')">In Progress ({{ deactiveUsers}})</v-tab>
                            <v-tab @click="changeUserStatusType('completed')">Completed ({{ importedUsers }})</v-tab>
                        </v-tabs>
                    </template> -->
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="10"
            v-model="selected"
            show-select
            :loading="loading"
            loading-text="Loading Users... Please wait"
            :footer-props="{
              'items-per-page-options': [10, 25, 50],
              'show-first-last-page': true,
              'show-current-page': true,
              'items-per-page-text': 'Users per page',
            }"
            :options.sync="options"
            hide-default-footer
          >
            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-select
                  :items="['Medical', 'Insemination']"
                  outlined
                  dense
                  class="shrink wdt"
                  v-model="action"
                ></v-select>
                <!-- <v-text-field
                                prepend-inner-icon="mdi-magnify"
                                outlined
                                height="5px"
                                placeholder="Search"
                                dense
                                v-model="search"
                                @click:append="searchUsers"
                                @input="resetSearchOnEmpty"
                                class="shrink ml-8"
                            ></v-text-field> -->
                <v-btn
                  color="primary"
                  height="40"
                  class="ml-4"
                  @click="submitRecord"
                >
                 {{$t('actionListmod.healthRecord')}}
                </v-btn>
                <v-spacer></v-spacer>
                <!-- <div class="py-1 title">{{ from }} - {{ to }} of {{ totalUsers }}</div> -->
                <!-- <v-btn
                                class="mx-2"
                                fab
                                small
                                outlined
                                color="primary"
                                :disabled="options.page<=1"
                                @click="pageChange(false)"
                            >
                                <v-icon dark>
                                    mdi-chevron-left
                                </v-icon>
                            </v-btn>
                            <v-btn
                                class="mx-2"
                                fab
                                small
                                outlined
                                color="primary"
                                :disabled="options.page>=totalPages"
                                @click="pageChange(true)"
                            >
                                <v-icon dark>
                                    mdi-chevron-right
                                </v-icon>
                            </v-btn> -->
                <!-- <v-btn
                                class="mx-2"
                                fab
                                small
                                outlined
                                color="primary"
                                disabled
                            >
                                <v-icon dark>
                                    mdi-cog-outline
                                </v-icon>
                            </v-btn> -->
              </div>
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="6"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data v-if="items.length < 1">
              {{$t('actionListmod.noTaskAvailable')}}
            </template>
            <template v-if="items.length > 0" v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.email"
                  @mouseover="selectItem(item)"
                  @mouseleave="unSelectItem()"
                  style="position: relative; width: 0; height: 0"
                >
                  <td>
                    <v-checkbox
                      multiple
                      v-model="selected"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                    />
                  </td>
                  <td>
                    {{ item.animal.animalNumber }}
                  </td>
                  <td>{{ item.animal.tagNumber }}</td>
                  <td class="capitlize">{{ item.animal.dob }}</td>
                  <td class="capitlize">{{ item.priority }}</td>
                  <td class="capitlize text-center">
                    {{ item.gender }}
                  </td>
                  <td class="capitlize text-center">
                    {{ item.animal.breed }}
                  </td>
                  <td>{{ item.animal.createdAt }}</td>
                  <td>
                    <v-btn
                      x-small
                      rounded
                      min-width="120"
                      :color="item.status !== '1' ? 'green2' : 'red2'"
                      depressed
                      :class="
                        item.status !== '1' ? 'primary--text' : 'red--text'
                      "
                      height="34"
                    >
                      {{ item.status == 1 ? "Active" : "Completed" }}
                    </v-btn>
                  </td>
                  <!-- <div style="position: absolute; right: 10px; top:5px;" v-if="item === selectedItem">  
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    x-small 
                                    fab
                                    v-bind="attrs"
                                    v-on="on"
                                    class="green-shadow"
                                >
                                    <v-icon>mdi-pencil</v-icon> 
                                </v-btn>
                            </template>
                            <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="showStatusType == 'active'">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    x-small 
                                    fab
                                    v-bind="attrs"
                                    v-on="on"
                                    class="ml-1 green-shadow"
                                    > 
                                        <v-icon>mdi-trash-can</v-icon> 
                                </v-btn>
                            </template>
                            <span>Deactivate</span>
                        </v-tooltip>
                        <v-tooltip bottom v-else>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    x-small 
                                    fab
                                    v-bind="attrs"
                                    v-on="on"
                                    class="ml-1 green-shadow"
                                    > 
                                        <v-icon>mdi-play</v-icon> 
                                </v-btn>
                            </template>
                            <span>Activate</span>
                        </v-tooltip>
                    </div> -->
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <v-row class="mt-5">
            <v-col lg="3" md="4" sm="4" xs="6">
              <label
                class="subtitle-1 font-weight-medium black--text"
                for="breed"
                >{{$t('actionListmod.assignTo')}}</label
              >
              <v-text-field
                type="text"
                placeholder="e.g XXXX"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col lg="3">
              <label
                class="subtitle-1 font-weight-medium black--text"
                for="breed"
                >{{$t('actionListmod.status')}}</label
              >
              <v-text-field
                type="text"
                placeholder="e.g XXXX"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col lg="6">
              <label
                class="subtitle-1 font-weight-medium black--text"
                for="breed"
                >{{$t('actionListmod.nOTE')}}</label
              >
              <v-text-field
                type="text"
                placeholder="e.g XXXX"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";

export default {
  mounted() {
    document.title = "Action List - Daily Task";
    const fetchData = async () => {
      await this.getTask(this.$route.params.task_id);
    };
    if (this.checkBreakPoints) this.tabletGetTask(this.$route.params.task_id);
    else fetchData();
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },

  watch: {
    //   options: {
    //     handler () {
    //       this.getTaskData()
    //     },
    //     deep: true,
    //   },
  },
  methods: {
    getTask(taskId) {
      this.startLoading();
      this.$store
        .dispatch("getSingleTaskDetails", taskId)
        .then((result) => {
          // console.log('res',result)
          this.task = result.data.task;
          this.items = result.data.task.animal;
        })
        .catch((err) => {
          console.log("err", err);
        })
        .finally(() => {
          this.stopLoading();
        });
    },
    tabletGetTask(taskId) {
      this.startLoading();
      this.$store
        .dispatch("getSingleTaskDetails", taskId)
        .then((result) => {
          console.log("res", result);
          this.task = result.data.task;
          this.items = result.data.task.animal;
        })
        .catch((err) => {
          console.log("err", err);
        })
        .finally(() => {
          this.stopLoading();
        });
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    getDailyTasks() {
      // console.log('tbl',this.options, page, limit)
      // UserService.getUsers(page,limit, this.showStatusType, this.search, this.options.sortBy, this.options.sortDesc)
      // UserService.getUsers(this.options, this.showStatusType, this.search)
      // .then( res => {
      //     if(res.success){
      //         this.items = res.data.rows;
      //         this.totalUsers = res.data.totalRows;
      //         this.activeUsers = res.data.activeUsers;
      //         this.deactiveUsers = res.data.deactiveUsers;
      //         this.importedUsers = res.data.importedUsers;
      //         this.showingRows = res.data.numRows;
      //         this.pageCount = Math.ceil(this.totalUsers/this.options.itemsPerPage);
      //         this.totalPages = Math.ceil(this.totalUsers/this.options.itemsPerPage)
      //         this.from = (((this.options.page-1)*this.options.itemsPerPage)+1)
      //         this.to = (this.options.page*this.options.itemsPerPage)-(this.options.itemsPerPage-res.data.numRows)
      //         this.loading = false;
      //     }
      // })
      // .catch(err => {
      //     this.loading = false;
      //     this.items = []
      //     console.log(err)
      //     // if(err.response.status == 403)
      //         // this.$router.go(-1)
      // })
    },

    // changeUserStatusType(type) {
    //     if(this.showStatusType == type) return;
    //     this.showStatusType = type;
    //     this.options.page = 1;
    //     this.getDailyTasks()
    // },

    searchUsers() {
      if (this.search == "") return;
      this.options.page = 1;
      this.getDailyTasks();
    },

    resetSearchOnEmpty() {
      if (this.search != "") return;
      this.options.page = 1;
      this.getDailyTasks();
    },

    getTaskData() {
      this.getDailyTasks();
    },
    async submitRecord() {
      console.log(this.selected);
      let routeName =
        this.action == "Medical" ? "TaskHealthRecord" : "TaskInsemination";
      await localStorage.setItem("items", JSON.stringify(this.selected));
      this.$router.push({
        name: routeName,
        params: { task_id: this.$route.params.task_id },
      });
    },
    // confirmDeactivate(action, confirmData) {
    //     if(action) {
    //         this.startLoading()
    //         UserService.updateUser({userNumber: confirmData.user.userNumber, status: confirmData.status})
    //         .then( res => {
    //             if(res.success) {
    //                 this.getUsers();
    //                 this.stopLoading();
    //                 this.confirm = false;
    //                 this.$notify({
    //                     title: confirmData.status=='active' ? 'User Activated' :'User Deactivated',
    //                     text: res.message,
    //                     type: 'success'
    //                 });
    //             }else{
    //                 this.stopLoading();
    //                 this.confirm = false;
    //                 this.$notify({
    //                     title: 'Unable to update',
    //                     text: res.message,
    //                     type: 'error'
    //                 });
    //             }
    //         })
    //         .catch( err => {
    //             console.log(err)
    //             this.stopLoading();
    //             this.confirm = false;
    //         })
    //     }else{
    //         this.confirm = false;
    //     }
    // },

    pageChange(t) {
      if (t) this.options.page = this.options.page + 1;
      else this.options.page = this.options.page - 1;

      this.getTaskData();
    },
  },
  data() {
    return {
      action: "Medical",
      task: {},
      tab: 0,
      from: 0,
      to: 0,
      totalPages: 1,
      showingRows: 0,
      pageCount: 0,
      options: {},
      tabletTableOptions: { itemsPerPage: 5, page: 1, sortBy: [] },
      showStatusType: "1",
      search: "",
      selected: [],
      items: [
        {
          id: "ANI54658",
          tag: "TG26589",
          dob: "2021-05-22",
          priority: "High Priority",
          gender: "Male",
          breed: "Mixed Breed",
          regDate: "2021-07-24",
          status: 2,
        },
      ],
      selectedItem: false,
      loading: false,
      loadingText: "Loading... Please wait",
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('actionList'),
          disabled: false,
          to: { name: "ActionList" },
          exact: true,
        },
        {
          text: `#${this.$route.params.task_id}`,
          disabled: true,
        },
      ],
      headers: [
        {
          text: this.$t('actionListmod.iD'),
          align: "start",
          sortable: true,
          value: "name",
          class: "black--text",
        },
        {
          text: this.$t('actionListmod.tAG'),
          value: "email",
          class: "black--text",
        },
        {
          text: this.$t('actionListmod.dateOfbirth'),
          value: "role",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t('actionListmod.taskTakenat'),
          value: "department",
          class: "black--text",
        },
        {
          text: this.$t('actionListmod.gENDER'),
          value: "status",
          align: "center",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t('actionListmod.bREED'),
          value: "status",
          align: "center",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t('actionListmod.regDate'),
          value: "status",
          align: "center",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t('actionListmod.status'),
          value: "status",
          align: "center",
          sortable: false,
          class: "black--text",
        },
      ],
    };
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}
::v-deep .green-shadow:hover {
  background-color: $primary_color;
  color: white;
}
::v-deep .wdt {
  width: 250px;
}

.v-card-checkbox {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>